import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-08d40942")

_pushScopeId("data-v-08d40942")
const _hoisted_1 = { class: "exchange_container" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ExchangeHead = _resolveComponent("ExchangeHead")!
  const _component_ExchangeHome = _resolveComponent("ExchangeHome")!
  const _component_ExchangeSuccess = _resolveComponent("ExchangeSuccess")!
  const _component_SoftWareRecommend = _resolveComponent("SoftWareRecommend")!
  const _component_MyExchangeList = _resolveComponent("MyExchangeList")!
  const _component_FailModal = _resolveComponent("FailModal")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.viewModel.step !== 'list')
      ? (_openBlock(), _createBlock(_component_ExchangeHead, {
          key: 0,
          step: _ctx.viewModel.step,
          onStep: _ctx.updateStep
        }, null, 8, ["step", "onStep"]))
      : _createCommentVNode("", true),
    (_ctx.viewModel.step === 'home')
      ? (_openBlock(), _createBlock(_component_ExchangeHome, {
          key: 1,
          onStep: _ctx.updateStep,
          onSuccess: _ctx.handleExchangeSuccess,
          onErrCode: _ctx.handleExchangeErrCode
        }, null, 8, ["onStep", "onSuccess", "onErrCode"]))
      : (_ctx.viewModel.step === 'success')
        ? (_openBlock(), _createBlock(_component_ExchangeSuccess, {
            key: 2,
            info: _ctx.viewModel.exchangeSuccessInfo,
            onStep: _ctx.updateStep
          }, null, 8, ["info", "onStep"]))
        : (_ctx.viewModel.step === 'recommend')
          ? (_openBlock(), _createBlock(_component_SoftWareRecommend, {
              key: 3,
              onStep: _ctx.updateStep
            }, null, 8, ["onStep"]))
          : (_ctx.viewModel.step === 'list')
            ? (_openBlock(), _createBlock(_component_MyExchangeList, {
                key: 4,
                onStep: _ctx.updateStep
              }, null, 8, ["onStep"]))
            : _createCommentVNode("", true),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withId(() => [
        (_ctx.viewModel.failModalVisible)
          ? (_openBlock(), _createBlock(_component_FailModal, {
              key: 0,
              "err-code": _ctx.viewModel.errCode,
              onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.viewModel.failModalVisible = false)),
              onOpenOfficialCode: _ctx.openOfficialCode
            }, null, 8, ["err-code", "onOpenOfficialCode"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
})